/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteProductCtrl',["$log","$scope","$anchorScroll","$rootScope","$routeParams","$location","ProductData","$timeout",
        function($log,$scope,$anchorScroll,$rootScope,$routeParams,$location,ProductData,$timeout)
        {
            $scope.currentProductId =  parseInt($routeParams.productId);
            $scope.redirectToHomeWhenAccessIsNotGranted();
            $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
            {
                if (newValue)// && !$scope.ad.view.currentProductView)
                {
                    var product = ProductData.getById( $scope.currentProductId);
                    if (product)
                    {
                        $scope.ad.msgErrorProduct = "";
                        $scope.setCurrentProductView($scope.ad.view.productCategoryRootView.getProductView(product),false);
                    }
                    else
                    {
                        $scope.ad.msgErrorProduct = "Nous sommes désolés mais cette prestation n'existe plus ou n'est plus réservable.";
                    }
                    $timeout(function() {
                        if(window.FB) {
                            window.FB.XFBML.parse();
                        }
                    },200);
                }
            });

        }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteProductCtrl.js